<template>
  <component :is="wrapperTag" :href="channel">
    <div
      class="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-primary-300 tw-p-2 md:tw-w-max"
      :class="[
        isUserGroupMember
          ? 'tw-text-primary-500 tw-transition-colors hover:tw-border-primary-100 hover:tw-bg-primary-100'
          : 'tw-cursor-not-allowed tw-select-none tw-text-primary-300',
      ]"
      v-tooltip="
        !isUserGroupMember &&
        'You need to be a member of the city squad to join the Slack channel.'
      "
    >
      <img
        class="tw-mr-2"
        src="../../../../assets/images/slack-24x24.png"
        alt="Slack logo"
      />
      <span class="tw-truncate">{{ channelName }}</span>
      <LockIcon
        v-if="!isUserGroupMember"
        class="tw-ml-2 tw-h-5 tw-w-5 tw-text-neutral-500"
      />
    </div>
  </component>
</template>

<script setup>
import LockIcon from '@/assets/images/icons/lock.svg'
import { computed } from 'vue'

const props = defineProps({
  isUserGroupMember: {
    type: Boolean,
    required: true,
  },
  channel: {
    type: String,
    default: '#',
  },
  channelName: {
    type: String,
    default: 'Slack',
  },
})

const wrapperTag = computed(() => (props.isUserGroupMember ? 'a' : 'div'))
</script>
